import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SearchAreaGetResponse } from './search-area-get-response';

@Injectable({ providedIn: 'root' })
export class SearchAreaApi {
  constructor(private afs: AngularFirestore) {}

  get(): Observable<SearchAreaGetResponse[]> {
    const searchAreasCollection = this.afs.collection<SearchAreaGetResponse>(
      'search_areas',
      ref => ref.orderBy('index'),
    );

    return searchAreasCollection.valueChanges();
  }

  /**
   * 指定された searchAreaGroup に紐づく searchArea の一覧を取得する。
   */
  getAllBySearchAreaGroup(
    searchAreaGroupId: string,
  ): Observable<SearchAreaGetResponse[]> {
    const searchAreasCollection = this.afs.collection<SearchAreaGetResponse>(
      `search_area_groups/${searchAreaGroupId}/search_areas`,
      ref => ref.orderBy('index'),
    );

    return searchAreasCollection.valueChanges();
  }
}
